export default "__VITE_ASSET__fd80ce16__"